module.exports = __webpack_public_path__ + "static/media/delete.a4495686.svg";